import Flex from '@Components/Bases/Flex';
import { Box, BoxProps, Typography } from '@mui/material';
import GhGasEmissionOrgFormFields from '@Router/EsgGreenhouse/Components/GhGasEmissionOrgFormFields';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import GreenhouseGasEmissionOrganizationRemark, {
  PREFIX_GH_GAS_EMISSTION_ORG_ID,
} from './GreenhouseGasEmissionOrganizationRemark';
import GreenhouseGasEmissionOrganizationTotalForm from './GreenhouseGasEmissionOrganizationTotalForm';

const FormWrapper = (props: BoxProps) => {
  return (
    <Box
      width={1}
      display={'grid'}
      gridTemplateColumns={'repeat(3, 1fr)'}
      gap={3}
      {...props}
    />
  );
};

const GreenhouseGasEmissionOrganizationForms = () => {
  const { progressData } = useProgressBar();
  const { watch } = useGreenhouseForm();

  const performanceGhGasMgmtReport = watch('performanceGhGasMgmtReport');

  const { isCompletedTh = false, isCompletedEn = false } =
    performanceGhGasMgmtReport?.completedSection ?? {};

  const startOperatingYear =
    (progressData?.report.startOperatingYear ?? new Date().getFullYear()) - 1;

  return (
    <Box mt={2}>
      <Flex gap={1}>
        <Box width={1} minWidth={235} maxWidth={350} />
        <FormWrapper ml={1}>
          {Array.from({ length: 3 })
            .map((_, index) => (
              <Typography key={index} textAlign={'center'} fontWeight={800}>
                {startOperatingYear - index}
              </Typography>
            ))
            .reverse()}
        </FormWrapper>
        <Box minWidth={20} />
      </Flex>
      <Flex mt={2} gap={1} alignItems={'center'}>
        <GreenhouseGasEmissionOrganizationTotalForm />
        <GreenhouseGasEmissionOrganizationRemark
          topic={'ปริมาณการปล่อยก๊าซเรือนกระจกรวม'}
          name="remarkTotalGhGas"
        />
      </Flex>
      <Box id={`${PREFIX_GH_GAS_EMISSTION_ORG_ID}-remarkTotalGhGas`} />
      <Flex mt={2} gap={1} alignItems={'center'}>
        <GhGasEmissionOrgFormFields
          scope="การปล่อยก๊าซเรือนกระจก - ขอบเขตที่ 1"
          inputProps={{
            name: 'performanceGhGasMgmtReport.ghGasEmissionVolume.ghGasScope1',
          }}
          isCompleteTh={isCompletedTh}
          isCompleteEn={isCompletedEn}
        />
        <GreenhouseGasEmissionOrganizationRemark
          topic={'การปล่อยก๊าซเรือนกระจก - ขอบเขตที่ 1'}
          name="remarkScope1"
        />
      </Flex>
      <Box id={`${PREFIX_GH_GAS_EMISSTION_ORG_ID}-remarkScope1`} />
      <Flex mt={2} gap={1} alignItems={'center'}>
        <GhGasEmissionOrgFormFields
          scope="การปล่อยก๊าซเรือนกระจก - ขอบเขตที่ 2"
          inputProps={{
            name: 'performanceGhGasMgmtReport.ghGasEmissionVolume.ghGasScope2',
          }}
          isCompleteTh={isCompletedTh}
          isCompleteEn={isCompletedEn}
        />
        <GreenhouseGasEmissionOrganizationRemark
          topic={'การปล่อยก๊าซเรือนกระจก - ขอบเขตที่ 2'}
          name="remarkScope2"
        />
      </Flex>
      <Box id={`${PREFIX_GH_GAS_EMISSTION_ORG_ID}-remarkScope2`} />
      <Flex mt={2} gap={1} alignItems={'center'}>
        <GhGasEmissionOrgFormFields
          scope="การปล่อยก๊าซเรือนกระจก - ขอบเขตที่ 3"
          inputProps={{
            name: 'performanceGhGasMgmtReport.ghGasEmissionVolume.ghGasScope3',
          }}
          isCompleteTh={isCompletedTh}
          isCompleteEn={isCompletedEn}
        />
        <GreenhouseGasEmissionOrganizationRemark
          topic={'การปล่อยก๊าซเรือนกระจก - ขอบเขตที่ 3'}
          name="remarkScope3"
        />
      </Flex>
      <Box id={`${PREFIX_GH_GAS_EMISSTION_ORG_ID}-remarkScope3`} />
    </Box>
  );
};

export default GreenhouseGasEmissionOrganizationForms;
